import React, { useState, useRef, useEffect, useMemo, useCallback} from 'react';
import { AgGridReact } from 'ag-grid-react';
import axios from "axios";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Button,Form } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import './App.css'
import DeleteIcon from '@mui/icons-material/Delete';
import EditOffIcon from '@mui/icons-material/EditOff';
import SaveIcon from '@mui/icons-material/Save';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const App = () => {

    const  deleteComp=()=>{
      return(
         <>
             <Button size="sm" style={{margin:'1px',background:'#ff003a',borderRadius:'2px',padding:'8px'}} appearance="primary" >
                 <DeleteIcon fontSize={'20px'} />
             </Button>
             <Button size="sm" style={{margin:'1px',background:'#237f90',borderRadius:'2px',padding:'8px'}} appearance="primary" >
                 <EditOffIcon fontSize={'20px'} />
             </Button>
             </>
      )
    };

    const [rowData, setRowData] = useState();
    const [columnDefs, setColumnDefs] = useState([
        {field: 'loc',headerName: "State Name",width:450, rowDrag: true},
        {field: 'totalConfirmed',headerName: "Total Confirmed",width:200},
        {field: 'discharged',headerName: "Discharge",width:150},
        {field: 'deaths',headerName: "Deaths",width:100},
        {field: 'confirmedCasesIndian',headerName: "Indian Cases",width:200},
        {field: 'confirmedCasesForeign',headerName: "Foreign Cases",width:180},
        {headerName: "Action",width:100,cellRenderer:deleteComp}
    ]);

    const defaultColDef = useMemo( ()=> ({
        sortable: true,
        filter:true,
        resizable: true

    }));

    const getAPIData=async ()=>{
        let res =await axios("https://api.rootnet.in/covid19-in/stats/latest");
        setRowData(res.data.data.regional);
    };

    useEffect(() => {
        getAPIData();
    }, []);

  return (
      <div style={{background:'#29123d',height:'100vh'}}>
          <div className='container'>
              <br/>
              <h3 className='mt-4 mb-2 text-light'>Fill Data</h3>
              <form>
                  <div className='row'>
                      <div className='col-md-4'>
                          <div className='form-group'>
                              <label className='text-light'>State Name</label>
                              <input type='text' required placeholder='Enter here'  className='form-control'/>
                          </div>
                      </div>
                      <div className='col-md-4'>
                          <div className='form-group'>
                              <label className='text-light'>Total Confirmed</label>
                              <input type='text' required placeholder='Enter here'  className='form-control'/>
                          </div>
                      </div>
                      <div className='col-md-4'>
                          <div className='form-group'>
                              <label className='text-light'>Discharge</label>
                              <input type='text' required placeholder='Enter here'  className='form-control'/>
                          </div>
                      </div>
                      <div className='col-md-4'>
                          <div className='form-group'>
                              <label className='text-light'>Deaths</label>
                              <input type='text' required placeholder='Enter here'  className='form-control'/>
                          </div>
                      </div>
                      <div className='col-md-4'>
                          <div className='form-group'>
                              <label className='text-light'>Indian Case</label>
                              <input type='text' required placeholder='Enter here'  className='form-control'/>
                          </div>
                      </div>
                      <div className='col-md-4'>
                          <div className='form-group'>
                              <label className='text-light'>Foreign Case</label>
                              <input type='text' required placeholder='Enter here'  className='form-control'/>
                          </div>
                      </div>
                      <div className='text-center col-md-12'>
                          <Button type={'submit'} color="violet" appearance="primary" className="m-2">
                              <SaveIcon fontSize={'20px'} />&nbsp; Save Data
                          </Button>
                          <Button appearance="default" className="m-2">
                              <RestartAltIcon fontSize={'20px'} />&nbsp; Reset Data
                          </Button>
                      </div>

                  </div>
              </form><br/>
          </div>
          <div className='container-fluid'>
      <div className="ag-theme-alpine" style={{height: 400, width: '100%'}}>
        <AgGridReact
            defaultColDef={defaultColDef}
            animateRows={true}
            rowData={rowData}
            rowSelection='multiple'
            rowDragManaged={true}
            columnDefs={columnDefs}>
        </AgGridReact>
      </div>
          </div>
      </div>
  );
};

export default App;
